<template>
  <div data-page="add-program">
    <NewProgramComponent>
      <h1>{{ $t('add-program-headline') }}</h1>
      <p>{{ $t('add-program-body') }}</p>
    </NewProgramComponent>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, reactive, ref } from 'vue';
import NewProgramComponent from '../../components/NewProgramComponent.vue';
import Manager from '../../core/Manager';
import Submission from '../quality-mentoring-form/models/submission/Submission';
import { getLocale } from '../../core/Utils';
import RestService from 'restService';

onMounted(async () => {
  const user = Manager.getInstance().user;
  if (!user.initialAssessmentCreated) {
    Manager.getInstance().submission = new Submission();
    const submission = reactive(Manager.getInstance().submission);
    submission.name = user.initialProgramName;
    submission.organizationName = user.organization;
    submission.role = user.role;
    await submission.save();
    await Manager.getInstance().submissions.add(submission);
    window.location.href = `/${getLocale()}/overview?id=${submission.id}`;
  } else {
    document.body.classList.remove('loading');
  }
});
</script>
